import React from 'react';
import PageHeader from '../components/PageHeader';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const FreeConsultation = () => {
  return (
    <div className="w-full bg-brand-light min-h-screen">
      <PageHeader 
        title="Free Compliance & Preparedness Consultation" 
        description="Discuss your plans, training, exercises, compliance gaps, and leadership development needs." 
      />
      
      <section className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12">
          
          <div className="lg:col-span-4">
            <div className="bg-brand-navy text-white p-8 rounded-2xl shadow-xl sticky top-28">
              <h3 className="text-2xl font-bold mb-6 text-brand-green">What to Expect</h3>
              <p className="text-slate-300 mb-8 font-medium leading-relaxed">
                This is a practical, zero-pressure conversation to understand where your organization currently stands and identify potential gaps in your emergency readiness framework. 
              </p>
              <ul className="space-y-4">
                {[
                  'Current emergency plans',
                  'Hazardous materials',
                  'Compliance gaps',
                  'Workforce readiness',
                  'Leadership development'
                ].map((topic, i) => (
                  <li key={i} className="flex items-center gap-3 text-sm font-semibold">
                    <SafeIcon icon={FiIcons.FiCheckCircle} className="text-brand-green text-lg shrink-0" />
                    {topic}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-slate-200">
              <h2 className="text-2xl font-bold text-brand-navy mb-8">Request a Consultation</h2>
              
              <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">Name</label>
                    <input type="text" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium text-slate-900" />
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">Job Title</label>
                    <input type="text" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium text-slate-900" />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">Company</label>
                    <input type="text" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium text-slate-900" />
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">Industry</label>
                    <input type="text" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium text-slate-900" />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">Work Email</label>
                    <input type="email" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium text-slate-900" />
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">Phone</label>
                    <input type="tel" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium text-slate-900" />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">Location</label>
                    <input type="text" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium text-slate-900" />
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">Time Zone</label>
                    <input type="text" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium text-slate-900" />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-2">Service Needed</label>
                  <div className="relative">
                    <select className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all appearance-none font-medium text-slate-900">
                      <option>Emergency Planning</option>
                      <option>Compliance Consulting</option>
                      <option>Drills & Exercises</option>
                      <option>Training & Development</option>
                      <option>Leadership Development</option>
                      <option>Not Sure / Other</option>
                    </select>
                    <SafeIcon icon={FiIcons.FiChevronDown} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-slate-500 pointer-events-none" />
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">Preferred Meeting Dates/Times</label>
                    <input type="text" placeholder="e.g. Tuesday Mornings" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium text-slate-900" />
                  </div>
                  <div>
                    <label className="block text-sm font-bold text-slate-700 mb-2">Preferred Contact Method</label>
                    <div className="relative">
                      <select className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all appearance-none font-medium text-slate-900">
                        <option>Email</option>
                        <option>Phone Call</option>
                        <option>Video Call</option>
                      </select>
                      <SafeIcon icon={FiIcons.FiChevronDown} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-slate-500 pointer-events-none" />
                    </div>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-2">Current Plan/Program Status</label>
                  <input type="text" placeholder="e.g. Need to build from scratch, needs updating, etc." className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all font-medium text-slate-900" />
                </div>

                <div>
                  <label className="block text-sm font-bold text-slate-700 mb-2">Main Concern</label>
                  <textarea rows="4" required className="w-full p-3 bg-slate-50 border border-slate-200 rounded-xl focus:bg-white focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all resize-none font-medium text-slate-900"></textarea>
                </div>

                <button type="submit" className="w-full py-4 bg-brand-green text-white font-bold rounded-xl hover:bg-green-600 transition-colors shadow-lg shadow-brand-green/20">
                  Submit Request
                </button>
              </form>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
};

export default FreeConsultation;